module.exports = {
    fadeZoom: {
        0: {
            opacity: 0,
            scale: 0.95
        },
        1: {
            opacity: 1,
            scale: 1
        }
    },
    fadeZoomOut: {
        1: {
            opacity: 1,
            scale: 1
        },
        0: {
            opacity: 0,
            scale: 0
        }
    }
};
